import { applyMiddleware, createStore } from "redux";
import { loadUser } from "redux-oidc";
import thunkMiddleware from "redux-thunk";
import reducer from "@store/reducer";
import userManager from "@auth/userManager";
import { composeWithDevTools } from "redux-devtools-extension";
import { initialState as initailPdf } from "@store/reducer/pdf";
import { initialState as initailUpload } from "@store/reducer/upload";
import pdfJobsMiddleware from "@store/middlewares/PdfJobsMiddleware";
import { appsMock } from "@mocks/apps.mock";
const initialState = {
    oidc: {
        user: undefined,
        isLoadingUser: false
    },
    pdf: { ...initailPdf },
    upload: { ...initailUpload },
    apps: appsMock
};
const createStoreWithMiddleware = composeWithDevTools(applyMiddleware(thunkMiddleware, pdfJobsMiddleware))(createStore);
const store = createStoreWithMiddleware(reducer, initialState);
loadUser(store, userManager);
export const mockStore = (data = {}) => ({
    ...initialState,
    ...data
});
export default store;
